<template>
  <div
    class="asc-removals-timeline-wrapper--container"
    data-automation-id="wrapper_removals_timeline"
  >
    <div class="asc-removals-timeline-wrapper--filters">
      <asc-filters
        id="123456"
        :dense="false"
        no-placeholder
        :display-error-message="false"
        :lookups="filterLookups"
        :fields="removalsFilterFields"
        :on-filters-change="handleFiltersChange"
        :on-submit="handleFiltersSubmit"
        :on-disable-submit="handleFiltersDisableSubmit"
      >
      </asc-filters>
    </div>
    <asc-timeline-chart :flags="removalsData"></asc-timeline-chart>
  </div>
</template>

<script>
import AscFilters from '@/components/molecules/AscFilters'
import AscTimelineChart from '@/components/molecules/AscTimelineChart'

export default {
  name: 'AscRemovalsTimelineWrapper',

  components: {
    AscFilters,
    AscTimelineChart,
  },

  props: {
    removalsData: {
      type: Array,
      default: () => [],
    },
    onFiltersChange: {
      type: Function,
      default: () => {},
    },
    onFiltersSubmit: {
      type: Function,
      default: () => {},
    },
    onFiltersDisableSubmit: {
      type: Function,
      default: () => {},
    },
    removalsFilterFields: {
      type: Array,
      default: () => [],
    },
    filterLookups: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      items: [],
    }
  },

  methods: {
    handleFiltersChange() {
      this.items = []
    },

    handleFiltersSubmit(filters) {
      if (this.onFiltersSubmit) {
        this.onFiltersSubmit(filters)
      }
    },

    handleFiltersDisableSubmit() {
      this.items = []
    },
  },
}
</script>

<style lang="scss">
.asc-removals-timeline-wrapper--container {
  .asc-removals-timeline-wrapper--filters {
    margin-bottom: 16px;
  }
}
</style>
